import React from 'react'
import Theme from '../theme/Theme' 
export const Title = (props) => {  
  return (
    <div  onClick={(e)=>{
      e.preventDefault(); 
    }} style={{...Theme()?.title,...props?.style}}>{props?.data}{props?.children}</div>
  )
}
export default Title